import type { ProposalHeading } from '../types/proposal';

export const comprehensiveProposal: ProposalHeading[] = [
  { id: 't5-hs1', title: 'Introduction', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs3', title: 'Project Background', enabled: true, type: 'default', level: 1 },
  {
    id: 't5-hs4',
    title: 'Acknowledgement of conditions',
    enabled: true,
    type: 'default',
    level: 2,
  },
  {
    id: 't5-hs5',
    title: 'Confirmation of compliance with all requirements',
    enabled: true,
    type: 'default',
    level: 2,
  },
  {
    id: 't5-hs6',
    title: 'Any clarifications or exceptions noted',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs7', title: 'Company Profile', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs8', title: 'Who We Are', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs9', title: 'Our Expertise', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs10', title: 'Our Track Record', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs11',
    title: 'Understanding of the problem',
    enabled: true,
    type: 'default',
    level: 1,
  },
  { id: 't5-hs12', title: 'Client Objectives', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs13',
    title: 'Scope of Work (as you understand it)',
    enabled: true,
    type: 'default',
    level: 2,
  },
  {
    id: 't5-hs14',
    title: 'Key Challenges and Opportunities',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs15', title: 'Proposed Methodology', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs16', title: 'Technical Approach', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs17', title: 'Project Management Approach', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs18', title: 'Risk Management', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs19',
    title: 'Innovation and Value-Add Opportunities',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs20', title: 'Project Team & Resources', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs21', title: 'Organisation Chart', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs22',
    title: 'Key Personnel Profiles (include CV summaries)',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs23', title: 'Roles and Responsibilities', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs24',
    title: 'Subconsultants / Partners (if applicable)',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs25', title: 'Relevant Experience', enabled: true, type: 'default', level: 1 },
  {
    id: 't5-hs26',
    title: 'Case studies of similar projects',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs27', title: 'Program & Deliverables', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs28', title: 'Proposed Schedule', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs29', title: 'Milestones', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs30', title: 'Quality Assurance & Safety', enabled: true, type: 'default', level: 1 },
  { id: 't5-hs31', title: 'QA processes', enabled: true, type: 'default', level: 2 },
  {
    id: 't5-hs32',
    title: 'Environmental considerations',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs33', title: 'Pricing', enabled: true, type: 'default', level: 1 },
  {
    id: 't5-hs34',
    title: 'Pricing Schedule (as per tender requirements)',
    enabled: true,
    type: 'default',
    level: 2,
  },
  { id: 't5-hs35', title: 'Assumptions and Exclusions', enabled: true, type: 'default', level: 2 },
  { id: 't5-hs36', title: 'Optional Services (if any)', enabled: true, type: 'default', level: 2 },
];

export const templates: { name: string; structure: ProposalHeading[] }[] = [
  {
    name: 'Comprehensive Proposal',
    structure: comprehensiveProposal,
  },
  {
    name: 'Standard Proposal',
    structure: [
      { id: 't1-hs1', title: 'Introduction', enabled: true, type: 'default', level: 1 },
      { id: 't1-hs2', title: 'Client Understanding', enabled: true, type: 'default', level: 1 },
      { id: 't1-hs3', title: 'Proposed Solution', enabled: true, type: 'default', level: 1 },
      { id: 't1-hs4', title: 'Scope of Work', enabled: true, type: 'default', level: 1 },
      { id: 't1-hs5', title: 'Project Timeline', enabled: true, type: 'default', level: 1 },
      { id: 't1-hs6', title: 'Pricing', enabled: true, type: 'default', level: 1 },
    ],
  },
  {
    name: 'Detailed Technical Proposal',
    structure: [
      { id: 't2-hs1', title: 'Executive Summary', enabled: true, type: 'default', level: 1 },
      { id: 't2-hs2', title: 'Problem Statement', enabled: true, type: 'default', level: 1 },
      { id: 't2-hs3', title: 'Technical Approach', enabled: true, type: 'default', level: 1 },
      { id: 't2-hs4', title: 'Architecture Overview', enabled: true, type: 'default', level: 2 },
      { id: 't2-hs5', title: 'Component Design', enabled: true, type: 'default', level: 3 },
      { id: 't2-hs6', title: 'Data Flow', enabled: true, type: 'default', level: 3 },
      { id: 't2-hs7', title: 'Implementation Plan', enabled: true, type: 'default', level: 1 },
      { id: 't2-hs8', title: 'Testing Strategy', enabled: true, type: 'default', level: 2 },
      { id: 't2-hs9', title: 'Team Composition', enabled: true, type: 'default', level: 1 },
      { id: 't2-hs10', title: 'Commercial Proposal', enabled: true, type: 'default', level: 1 },
    ],
  },
  {
    name: 'Consulting Engagement',
    structure: [
      { id: 't4-hs1', title: 'Engagement Objectives', enabled: true, type: 'default', level: 1 },
      {
        id: 't4-hs2',
        title: 'Discovery & Analysis Phase',
        enabled: true,
        type: 'default',
        level: 1,
      },
      { id: 't4-hs3', title: 'Stakeholder Interviews', enabled: true, type: 'default', level: 2 },
      { id: 't4-hs4', title: 'As-Is Process Mapping', enabled: true, type: 'default', level: 2 },
      { id: 't4-hs5', title: 'Recommendations Phase', enabled: true, type: 'default', level: 1 },
      { id: 't4-hs6', title: 'To-Be Process Design', enabled: true, type: 'default', level: 2 },
      {
        id: 't4-hs7',
        title: 'Roadmap for Implementation',
        enabled: true,
        type: 'default',
        level: 2,
      },
      { id: 't4-hs8', title: 'Engagement Team', enabled: true, type: 'default', level: 1 },
      { id: 't4-hs9', title: 'Professional Fees', enabled: true, type: 'default', level: 1 },
    ],
  },
  {
    name: 'Panel Application',
    structure: [
      { id: 't6-hs1', title: 'Introduction', enabled: true, type: 'default', level: 1 },
      { id: 't6-hs2', title: 'Company Overview', enabled: true, type: 'default', level: 1 },
      { id: 't6-hs3', title: 'Company Profile', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs4', title: 'Core Capabilities', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs5', title: 'Insurances & Compliance', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs6', title: 'Team Capability', enabled: true, type: 'default', level: 1 },
      { id: 't6-hs7', title: 'Organisational Chart', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs8', title: 'Key Personnel Profiles', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs9', title: 'Resourcing Strategy', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs10', title: 'Relevant Experience', enabled: true, type: 'default', level: 1 },
      { id: 't6-hs11', title: 'Case Studies', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs12', title: 'Client Referees', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs13', title: 'Methodology', enabled: true, type: 'default', level: 1 },
      { id: 't6-hs14', title: 'Service Delivery Model', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs15', title: 'Quality Assurance', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs16', title: 'WHS Management', enabled: true, type: 'default', level: 2 },
      {
        id: 't6-hs17',
        title: 'Panel Specific Requirements',
        enabled: true,
        type: 'default',
        level: 1,
      },
      { id: 't6-hs18', title: 'Regional Coverage', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs19', title: 'Value for Money', enabled: true, type: 'default', level: 2 },
      { id: 't6-hs20', title: 'Rate Card / Pricing', enabled: true, type: 'default', level: 1 },
    ],
  },
];
